import styled from 'styled-components';

import { Picture } from 'components/picture';

import { theme } from './theme';

export const CartItemButton = styled.button`
  min-width: 250px;
  display: flex;
  flex-direction: row;
  scroll-snap-align: start;
  justify-content: space-between;
  align-items: center;
  background-color: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  margin-block: 4px;
  margin-inline-start: 4px;
  margin-inline-end: 10px;
  padding: 20px 15px;
  border: none;
  cursor: pointer;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${theme.fontFamily};
  color: ${Styles.color.black};
  line-height: 1.5;
`;

export const CartItemIcon = styled.div`
  color: ${Styles.color.primary};
  font-size: 2.5rem;
  padding: 1px 6px;
  ${Styles.desktop} {
    padding: 0 12px;
  }
`;

export const CartItemPicture = styled(Picture)`
  width: 70px;
  height: 50px;
  margin-inline-end: 8px;
`;

export const CartItemInfo = styled.div`
  font-size: 0.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CartItemName = styled.div`
  font-size: 0.9375rem;
`;

export const CartItemDetails = styled.div`
  text-align: start;
`;

export const CartItemPrice = styled.span`
  font-weight: bold;
  display: inline;
`;

export const CartItemCalories = styled.div`
  color: #626262;
  padding-inline-start: 5px;
  display: inline;
`;
